export const SET_ACTIVITY_CALENDAR_DATES = 'SET_ACTIVITY_CALENDAR_DATES';
export const SET_ACTIVITY_CALENDAR_DATE = 'SET_ACTIVITY_CALENDAR_DATE';
export const SET_ACTIVITY_CALENDAR_MODE = 'SET_ACTIVITY_CALENDAR_MODE';
export const RESET_ACTIVITY_CALENDAR_DATES = 'RESET_ACTIVITY_CALENDAR_DATES';


// WEBPACK FOOTER //
// ./src/store/modules/activity-calendar/mutations.js